import { render, staticRenderFns } from "./GoogleTranslate.vue?vue&type=template&id=5ae388f6&"
import script from "./GoogleTranslate.vue?vue&type=script&lang=js&"
export * from "./GoogleTranslate.vue?vue&type=script&lang=js&"
import style0 from "./GoogleTranslate.vue?vue&type=style&index=0&id=5ae388f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports